import { isValidElement } from "react";

/**
 * Check if an element is a DOM type (such as <div/> or <li/>) or a custom component like <Button/>
 * @param element
 */
export const isDOMTypeElement = (element: React.ReactNode) => {
    return isValidElement(element) && typeof element.type === "string";
};
